import script from "./side-menu-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-menu-item.vue?vue&type=script&setup=true&lang=ts"

import "./side-menu-item.vue?vue&type=style&index=0&id=0c04b20c&lang=scss"

const __exports__ = script;

export default __exports__